var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4729 6.72595V19.579H30.5741V21.6486H19.3944V6.73569C12.224 7.3003 6.56965 13.3088 6.56965 20.6227C6.56965 28.3087 12.814 34.553 20.5 34.553C28.186 34.553 34.4304 28.3087 34.4304 20.6227C34.4304 13.2641 28.6985 7.22691 21.4729 6.72595ZM4.5 20.6227C4.5 11.7869 11.6642 4.62268 20.5 4.62268C29.3358 4.62268 36.5 11.7869 36.5 20.6227C36.5 29.4585 29.3358 36.6227 20.5 36.6227C11.6642 36.6227 4.5 29.4585 4.5 20.6227Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenClock.c3f2748deedf5b2cef427465d2602482.svg";